module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/high-capacity-transport-toolbar.e3405e1c.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/high-capacity-transport-toolbar.png
// module id = 3717
// module chunks = 11